import { render, staticRenderFns } from "./labelModal.vue?vue&type=template&id=f5ba8402&"
import script from "./labelModal.vue?vue&type=script&lang=ts&"
export * from "./labelModal.vue?vue&type=script&lang=ts&"
import style0 from "./labelModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports